import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class CertificationArchivesTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      certification_archives: [],
      certifications_list: [],
      certification_id: this.props.certification_id,
      archive_id: null,
    };

    //bind específico
    this.add = this.add.bind(this);
    this.deleteArchive = this.deleteArchive.bind(this);

    // Handlers
    this.locale = getLocale();

  }
  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.certifications_list) && (this.state.loaded === 0)) {
      this.setState({
        certifications_list: newProps.certifications_list,
      });
    }
    if(Array.isArray(newProps.certification_archives) && (this.state.loaded === 0)) {
      this.setState({
        certification_archives: newProps.certification_archives,
      });
    }
  }
  
  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    var self = this;
    this.props.handleAlert('', '', 'open');
    var datasave = {
      certification_id: this.state.certification_id,
      archive_id: this.state.archive_id,
    };
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/certificado/arquivo/morto', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({ loaded: 1 });
        self.setState({ certification_archives: responseJson.data });
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  deleteArchive (event) {
    var certification_archive_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Certificados.EditarCertificado.tabArquivoMorto.deletarArquivo);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/certificado/arquivo/' + certification_archive_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(certification_archive_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  deleteRow(certification_archive_id) {
    var certification_archives = this.state.certification_archives;
    certification_archives.map(function(dado, index){
      if (dado.id == certification_archive_id) {
        certification_archives.splice(index, 1);
      }
    });
    this.setState({certification_archives: certification_archives});
  }
  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h4>{this.locale.Certificados.EditarCertificado.tabArquivoMorto.adicionarCertificadoDeArquivoMorto}</h4>
  <hr/>
  <form onSubmit={this.add}>
    <div className="form-group">
      <label>{this.locale.Certificados.EditarCertificado.tabArquivoMorto.formularioArquivoMorto.Nome}:</label>
      <Select
        className="form-field-name"
        name="archive_id"
        value={this.state.archive_id}
        searchable={true}
        onChange={this.handleSelectChange.bind(this, 'archive_id')}
        options={this.state.certifications_list}
      />
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Certificados.EditarCertificado.tabArquivoMorto.formularioArquivoMorto.botaoAdicionarCertificadoDeArquivoMorto}</button>
  </form>
  <hr/>
  <table className="table table-hover tabled-striped table-bordered">
    <thead>
      <tr>
        <th>{this.locale.Certificados.EditarCertificado.tabArquivoMorto.tabelaArquivoMorto.Nome}</th>
        <th>{this.locale.Certificados.EditarCertificado.tabArquivoMorto.tabelaArquivoMorto.Acoes}</th>
      </tr>
    </thead>
    <tbody>
      {Object.keys(self.state.certification_archives).map(function(k) {
        return (
          <tr>
            <td className="col-md-5">{self.state.certification_archives[k].archive}</td>
            <td className="col-md-1 text-center">
              <button className="btn btn-sm btn-danger" value={self.state.certification_archives[k].id} onClick={self.deleteArchive}>
                <i className="fa fa-fw fa-trash"></i>
              </button>
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
</div>
    );
  }
}

export default CertificationArchivesTab;



// WEBPACK FOOTER //
// ./src/Components/Certifications/Elements/CertificationArchivesTab.js